import { render, staticRenderFns } from "./defaultTempEdit.vue?vue&type=template&id=4572dd9f&scoped=true"
import script from "./defaultTempEdit.vue?vue&type=script&lang=js"
export * from "./defaultTempEdit.vue?vue&type=script&lang=js"
import style0 from "./defaultTempEdit.vue?vue&type=style&index=0&id=4572dd9f&prod&lang=scss"
import style1 from "./defaultTempEdit.vue?vue&type=style&index=1&id=4572dd9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4572dd9f",
  null
  
)

export default component.exports